import React from 'react';
import { Snackbar } from 'material-ui';
import { connect } from 'react-redux';
import * as generalActions from 'modules/general/action';

@connect(store => ({
    snackbar: store.getIn(['general', 'snackbar'])
}))
export default class extends React.Component {
  constructor(props){
    super(props);
  }
  handleRequestClose(){
      this.props.dispatch(generalActions.snackbar_hide());
  }
  render(){
    return(
      <Snackbar
        className='snackbar'
        open={this.props.snackbar.get('open')}
        message={this.props.snackbar.get('message')}
        autoHideDuration={this.props.snackbar.get('duration')}
        onRequestClose={this.handleRequestClose.bind(this)}
      />
    );
  }
}



// WEBPACK FOOTER //
// src/modules/general/components/snackbar.js